"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const mark_parser_1 = require("@gojipress/mark-parser");
const textPlugin = {
    name: "text React Syntax Highlighter",
    pluginType: "react-renderer",
    types: [mark_parser_1.GMType.Text],
    render: node => {
        return [
            [{
                    element: function Text() {
                        return jsx_runtime_1.jsx(react_1.default.Fragment, { children: node.original }, void 0);
                    },
                }],
            undefined,
        ];
    }
};
exports.default = textPlugin;
